import { Pipe, PipeTransform } from '@angular/core';
import { ProductLookupResult } from '../Services/products.service';

@Pipe({
  name: 'formatSubstances',
  standalone: true,
})
export class FormatSubstancesPipe implements PipeTransform {
  transform(product: ProductLookupResult | null | undefined): string {
    if (!product?.active_substances?.length) {
      return '—';
    }
    return product.active_substances
      .map((s) => (s.strength ? `${s.name} (${s.strength})` : s.name))
      .join(', ');
  }
}
